<script>
export default {
  name: 'Chat',
  props: ['attendee'],
  data() {
    return {
      loaded: false,
      appId: '73599'
    }
  },
  created() {
    let chatDiv = document.createElement('div');
    chatDiv.setAttribute('class', 'pubble-app')
    chatDiv.setAttribute('data-app-id', this.appId)
    chatDiv.setAttribute('data-app-identifier', this.appId)
    chatDiv.setAttribute('data-user-name', this.attendee.name)
    chatDiv.setAttribute('data-user-email', this.attendee.email)
    chatDiv.setAttribute('data-user-type', 'Account')
    document.body.appendChild(chatDiv)

    let chat = document.createElement('script');
    chat.setAttribute('src',"https://cdn.chatify.com/javascript/loader.js");
    chat.setAttribute('defer', '')
    document.body.appendChild(chat);

    chat.addEventListener('load', () => {
      this.showChat()
    })
  },
  methods: {
    showChat() {
      this.loaded = true
    }
  }
}
</script>

<style lang="scss">
</style>
